import React from "react";
import Modal from "./Modal";

const Footer = (props) => {
  return (
    <div
      id={props.isNightMode ? "dark" : "light"}
      className="footer-main-container">
      <h1 id={props.isNightMode ? "dark" : "light"}>
        Let’s work together on your next product.
      </h1>
      <div className="footer-linkler-container">
        <a className="githubb" href="https://github.com/Busemutluoglu">
          Github
        </a>
        <a
          id={props.isNightMode ? "dark" : "light"}
          className="blog"
          href="top">
          Personel Blog
        </a>
        <a
          className="linkedinn"
          href="https://www.linkedin.com/in/buse-mutluoglu-18a8a8a0/">
          linkedin
        </a>
        <a className="email" href="busemutluoglu@gmail.com">
          Email
        </a>
        <div className="form">
          <a>Form ↓</a>

          <Modal className="modalheader" isNightMode={props.isNightMode} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
